import { useStore } from 'react-redux';

type StoryViewState = { storyView?: { open?: boolean } };

const useStoryViewOpen = () => {
  const store = useStore();
  const isStoryViewOpen = () => (store.getState() as StoryViewState)?.storyView?.open;
  return isStoryViewOpen;
};

export default useStoryViewOpen;
